/* Babycadeautjes.com landing — scoped scripts (Shopify) */
(function () {
  'use strict';
  var inEditor = !!(window.Shopify && window.Shopify.designMode);

  function initReveals(root) {
    var reveals = (root || document).querySelectorAll('.bc-reveal:not(.is-in)');
    if (inEditor || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    reveals.forEach(function (el) { io.observe(el); });
  }

  function initNamecards(root) {
    (root || document).querySelectorAll('[data-bc-namecard]').forEach(function (card) {
      if (card.getAttribute('data-bc-ready')) return;
      card.setAttribute('data-bc-ready', '1');
      var input = card.querySelector('input');
      var out = card.querySelector('[data-bc-name-out]');
      if (!input || !out) return;
      var fallback = out.getAttribute('data-placeholder') || out.textContent;
      var render = function () {
        var v = input.value.replace(/\s+/g, ' ').trim().slice(0, 14);
        out.textContent = v || fallback;
        out.style.opacity = v ? '1' : '.85';
      };
      input.addEventListener('input', render);
      render();
      card.querySelectorAll('[data-bc-color]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.getAttribute('data-bc-color');
          card.querySelectorAll('[data-bc-color-img]').forEach(function (el) { el.classList.toggle('is-active', el.getAttribute('data-bc-color-img') === id); });
          card.querySelectorAll('[data-bc-color-info]').forEach(function (el) { el.classList.toggle('is-active', el.getAttribute('data-bc-color-info') === id); });
          card.querySelectorAll('[data-bc-color]').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
          if (btn.getAttribute('data-bc-top')) out.style.setProperty('--bc-name-top', btn.getAttribute('data-bc-top') + '%');
          if (btn.getAttribute('data-bc-text')) out.style.setProperty('--bc-name-color', btn.getAttribute('data-bc-text'));
        });
      });
      card.querySelectorAll('[data-bc-font]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var f = btn.getAttribute('data-bc-font');
          out.className = out.className.replace(/\bbc-font-\d\b/g, '').trim() + ' bc-font-' + f;
          card.querySelectorAll('[data-bc-font]').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        });
      });
    });
  }

  function initFaq(root) {
    (root || document).querySelectorAll('.bc-faq').forEach(function (faq) {
      if (faq.getAttribute('data-bc-ready')) return;
      faq.setAttribute('data-bc-ready', '1');
      faq.addEventListener('toggle', function (e) {
        if (e.target.tagName === 'DETAILS' && e.target.open) {
          faq.querySelectorAll('details[open]').forEach(function (d) { if (d !== e.target) d.open = false; });
        }
      }, true);
    });
  }

  function initMarquees(root) {
    (root || document).querySelectorAll('.bc-marquee__track, .bc-strip__track').forEach(function (track) {
      if (track.getAttribute('data-duplicated')) return;
      track.innerHTML = track.innerHTML + track.innerHTML;
      track.setAttribute('data-duplicated', '1');
    });
  }

  function initAll(root) { initMarquees(root); initReveals(root); initNamecards(root); initFaq(root); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
